import {Component, Input, OnInit, Output, ViewChild, EventEmitter, OnChanges} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ColumnDefinition} from "./data-table-class.model";

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})


export class DataTableComponent implements OnInit {

  @Input() rows: any = [];
  @Input() columnDefs: ColumnDefinition[] = [];
  @Input() loading: boolean = false;
  @Input() defaultSort: string;
  @Input() showPagination: boolean = true;
  @Input() pagination: number = 10;
  @Input() stickyHeader: boolean = false;
  @Input() dateFormat: string;
  @Input() rowDelete: boolean = false;
  // @Input() searchText: string;
  pageEvent!: PageEvent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  tableRows: MatTableDataSource<any>;
  displayColumns: string[];
  @Output() onRowClicked = new EventEmitter();
  @Output() onRowDoubleClicked = new EventEmitter();
  @Output() onRowDelete = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    this.initializeTable();
  }

  ngOnChanges(): void{
    this.initializeTable();
  }

  initializeTable(rows?: any[]){
    this.tableRows = new MatTableDataSource(rows || this.rows as any[]);
    if(this.showPagination)
      this.tableRows.paginator = this.paginator;
    this.tableRows.sort = this.sort;
    if(this.columnDefs && this.columnDefs.length)
      this.displayColumns = this.columnDefs.map(item => item.field);
      if(this.rowDelete && !this.displayColumns.includes('deleteAction')){
        this.columnDefs.push({
          type: 'button',
          field: 'deleteAction',
          label: 'Action'
        })
        this.displayColumns.push('deleteAction');
      }
  }

  search(val: string) {
    this.tableRows.filter = val.trim().toLowerCase();
    if (this.tableRows.paginator) {
      this.tableRows.paginator.firstPage();
    }
  }
  rowClicked(row){
    this.onRowClicked.emit(row);
  }
  rowDblClicked(row) {
    this.onRowDoubleClicked.emit(row);
  }
  deleteRow(row){
    this.onRowDelete.emit(row);
  }
}
